<template>
  <div class="apply-exh">
    <div class="input">
      <van-field
        input-align="right"
        clickable
        required
        label="举办地点"
        placeholder="请输入地点"
        v-model="formData.site"
        error-message-align="right"
        :error-message="validate.fieldMsg.site"
      />

      <van-field
        input-align="right"
        clickable
        required
        readonly
        label="开始时间"
        placeholder="请选择时间"
        @click="popupTimePick('startTime')"
        v-model="formData.startTime"
        error-message-align="right"
        :error-message="validate.fieldMsg.startTime"
      />

      <van-popup v-model="choiceDatetime" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          :title="selectTimeTitle"
          :min-date="minDate"
          @confirm="setExhibitionTime"
          @cancel="choiceDatetime = false"
        />
      </van-popup>
      <van-field
        input-align="right"
        clickable
        required
        readonly
        label="结束时间"
        placeholder="请选择时间"
        @click="popupTimePick('endTime')"
        v-model="formData.endTime"
        error-message-align="right"
        :error-message="validate.fieldMsg.endTime"
      />

      <van-field
        input-align="right"
        clickable
        required
        label="展览主题"
        placeholder="请输入展览主题"
        v-model="formData.theme"
        error-message-align="right"
        :error-message="validate.fieldMsg.theme"
      />

      <van-field
        input-align="right"
        clickable
        required
        autosize
        rows="8"
        type="textarea"
        maxlength="1000"
        label="活动方案"
        placeholder="请输入活动方案"
        show-word-limit
        v-model="formData.programme"
        error-message-align="right"
        :error-message="validate.fieldMsg.programme"
      />

      <van-field label-class="affixs-label">
        <template name="affixs" #label>
          <span class="custom-title">方案附件</span>
          <span class="custom-tit">(可上传方案相关材料，最多五个)</span>
        </template> </van-field
      ><!-- 由于uploader 的小bug  此处 设置最大数量为 6 ，但当文件数量大于等于5时隐藏 上传点击按钮 -->
      <div
        :class="['affixs', affixs.length >= 5 ? 'hidden-upload' : '']"
        :style="{ marginBottom: '20px' }"
      >
        <van-uploader
          v-model="affixs"
          :max-count="6"
          :before-read="readImgUpload"
        >
          <!-- <van-uploader
          v-model="affixs"
          multiple
          :max-count="5"
          :after-read="readImgUpload"
          :before-read="readImgCompress"
        > -->
          <template #preview-cover="{ name }">
            <div class="preview-cover van-ellipsis">{{ name }}</div>
          </template>
        </van-uploader>
      </div>

      <van-field
        input-align="right"
        readonly
        clickable
        required
        label="活动规模"
        placeholder="选择规模"
        :value="scale"
        @click="scalePicker = true"
        error-message-align="right"
        :error-message="validate.fieldMsg.scaleVal"
      />
      <van-popup v-model="scalePicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="[
            {
              text: '100人以下',
              value: 0
            },
            {
              text: '100-150人',
              value: 1
            },
            {
              text: '150-200人',
              value: 2
            },
            {
              text: '200-300人',
              value: 3
            },
            {
              text: '300-500人',
              value: 4
            },
            {
              text: '500人以上',
              value: 5
            }
          ]"
          @confirm="scaleConfirm"
          @cancel="scalePicker = false"
        />
      </van-popup>

      <van-field
        clickable
        input-align="right"
        required
        label="主办方"
        placeholder="主办方名称，多个用逗号隔开"
        v-model="sponsor"
        error-message-align="right"
        :error-message="validate.fieldMsg.sponsor"
        @input="commaFormat($event, 'sponsor')"
      />

      <van-field
        clickable
        input-align="right"
        required
        label="协办方"
        placeholder="协办方名称，多个用逗号隔开"
        v-model="coOrganizer"
        error-message-align="right"
        :error-message="validate.fieldMsg.coOrganizer"
        @input="commaFormat($event, 'coOrganizer')"
      />
    </div>
    <div class="submit">
      <van-button
        size="large"
        @click="submit"
        color="linear-gradient(to right, #5DD682, #5AFF8E)"
        >提交</van-button
      >
    </div>
  </div>
</template>

<script>
import { dateFormat, checkUploadFile } from "@/utils/tool";
import { uploadFile } from "@/utils/api/user";
import { addSwExhibition } from "@/utils/api/channel";
import { validate } from "@/utils/mixin/validate";
export default {
  mixins: [validate],
  data() {
    return {
      // 选择时间类型
      selectKey: "",
      // 选择时间标题
      selectTimeTitle: "",
      // 方案附件
      affixs: [],
      // 活动规模
      scale: "",
      // 显示选择规模
      scalePicker: false,
      // 显示选择时间
      choiceDatetime: false,
      // 最小时间
      minDate: new Date(Date.now()),
      // 默认时间
      currentDate: new Date(),
      // 协办方
      coOrganizer: "",
      // 主办方
      sponsor: "",
      // 需要提交的表单信息
      formData: {
        site: null,
        startTime: null,
        endTime: null,
        theme: null,
        programme: null,
        file: null,
        scaleVal: null,
        sponsor: null,
        coOrganizer: null
      }
    };
  },
  watch: {
    sponsor: function (v) {
      this.formData.sponsor = v;
    },
    coOrganizer: function (v) {
      this.formData.coOrganizer = v;
    }
  },
  methods: {
    // 弹出时间选择
    popupTimePick(selectKey) {
      this.selectKey = selectKey;
      this.choiceDatetime = true;
      this.selectTimeTitle =
        selectKey === "startTime" ? "开始时间" : "结束时间";
    },
    // 选择时间
    setExhibitionTime(date) {
      this.formData[this.selectKey] = dateFormat(Date.parse(date));
      this.choiceDatetime = false;
    },
    //
    async readImgCompress(file) {
      // this.option.img = file.path;
      this.compress = true;
      return file;
    },
    // 选择附件
    readImgUpload(file) {
      let a = false;
      if (a) {
        return;
      }
      const pass = checkUploadFile(
        { file, size: 1000, type: 1, typestr: -1 },
        (err) => {
          this.$root.$toast.fail(err);
        }
      );
      if (!pass) {
        return false;
      }
      const id = `file_id_${Math.random().toString(32).slice(-8)}`;
      this.affixs.push({
        url: "",
        id,
        status: "uploading",
        message: "上传中...",
        name: file.name
      });
      this.$forceUpdate();
      let upfileobj = new FormData();
      upfileobj.append("file", file);
      uploadFile(upfileobj).then(({ success, data }) => {
        if (success) {
          const index = this.affixs.findIndex((e) => {
            return e.id === id;
          });
          this.affixs[index] = {
            url:data.fileUrl,
            status: "done",
            name: file.name
          };
          const strarr = this.affixs.map((e) => {
            return e.url;
          });
          this.formData.file = strarr.join(",");
          this.$forceUpdate();
          return success;
        } else {
          const index = this.affixs.findIndex((e) => {
            return e.id === id;
          });
          this.affixs[index] = {
            url: "",
            message: "上传失败，请重新上传",
            status: "failed",
            name: file.name
          };
          this.$forceUpdate();
          return false;
        }
      });
    },
    // 选择规模
    scaleConfirm(item) {
      this.scale = item.text;
      this.formData.scaleVal = item.value;
      this.scalePicker = false;
    },
    // 中文逗号变成英文逗号
    commaFormat(val, key) {
      this[key] = val.replace(/，/, ",");
    },
    // 数据校验提交
    async submit() {
      // 时间校验
      const s_time = Date.parse(this.formData.startTime);
      const e_time = Date.parse(this.formData.endTime);
      if (e_time <= s_time) {
        this.$root.$toast.fail("开始时间不能大于、等于结束时间！");
        return;
      }
      // 验证数据
      const dataValidate = () => {
        return new Promise((res) => {
          const lastKey = "coOrganizer";
          for (let key in this.formData) {
            if (key !== "file") {
              let pass = this.validate.isNull(key);
              if (!pass) res(false);
              if (key === lastKey) {
                res(true);
              }
              this.$forceUpdate();
            }
          }
        });
      };
      let result = await dataValidate();
      // result = false;
      if (!result) {
        this.validate.errMsgPopup();
        this.validate.errMsgEmpty();
        return;
      } else {
        const {
          site,
          startTime,
          endTime,
          theme,
          programme,
          file,
          scaleVal,
          sponsor,
          coOrganizer
        } = this.formData;
        let p = {
          address: site,
          coSponsor: coOrganizer,
          sponsor,
          startTime,
          endTime,
          scale: scaleVal,
          scheme: programme,
          title: theme,
          schemeEnclosure: file
        };
        if (!file) {
          delete p.schemeEnclosure;
        }
        addSwExhibition(p).then((res) => {
          if (res.success) {
            this.$root.$toast.success({
              message: "提交成功，请等待短信通知。",
              duration: 2000,
              onClose: () => {
                // this.$router.push("/home");
                this.$router.go(-1);
              }
            });
          }
        });
      }
    }
  },
  mounted() {
    this.validate.setFormDataKey("formData");
  }
};
</script>
<style lang="scss">
.apply-exh {
  text-align: left;
  background-color: #f9f9f9;
  .affixs.hidden-upload {
    .van-uploader {
      .van-uploader__upload {
        display: none;
      }
    }
  }
  .input {
    .van-cell {
      &::after {
        border: none;
      }
    }
  }
  .affixs-label {
    width: unset;
    & + .van-field__value {
      display: none;
    }
  }
  .custom-title {
  }
  .custom-tit {
    font-size: 12px;
    color: #cccccc;
  }
  .affixs {
    padding: 0 10px 20px 10px;
    background: #fff;
    @import "../../assets/css/customer.scss";
    .van-uploader {
      @include from-upload-style;
    }
  }
  .submit {
    margin: 0 auto;
    margin-top: 72px;
    margin-bottom: 40px;
    width: 254px;
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
}
</style>
